import React, { useEffect } from 'react';
import {
  SideNavigation, SideNavigationProps
} from '@amzn/awsui-components-react/polaris';
import { useNavigate } from 'react-router-dom';
import { useRouterStore } from '../../store/NavigationStore';


export function SideNavbar() {
  const navigationSettings = useRouterStore((state) => state.navigationSettings);
  let navigate = useNavigate();
  const [activeHref, setActiveHref] = React.useState<string | undefined>('/');
  const showPackViewer = (window as any).Configs['SHOW_OFFLINE_PACK_VIEWER'];
  const localOnly = (window as any).Configs['LOCAL_ONLY'];
  const showViewerV2 = (window as any).Configs['SHOW_VIEWER_V2'];
  const navItems: SideNavigationProps.Item[] = [
    {
      text: 'General',
      type: 'section',
      defaultExpanded: true,
      items: [
        { type: 'link', text: 'Viewer', href: '/general-map-viewer' },
        { type: 'link', text: 'Viewer - Compare mode', href: '/general-map-viewer-compare' },
        { type: 'link', text: 'Viewer - Slider mode', href: '/general-map-viewer-slider' },
      ]
    },
    {
      text: 'Offline Maps',
      type: 'section',
      defaultExpanded: true,
      items: [
        { type: 'link', text: 'Dashboard', href: '/offline-maps-dashboard' }

      ]
    },
    {
      text: 'Tile Validation',
      type: 'section',
      defaultExpanded: true,
      items: [
        {type: 'link', text: 'Metrics', href: '/tile-validation-metrics'},
      ]
    },
    {
      text: 'Stylesheets',
      type: 'section',
      defaultExpanded: true,
      items: [
        { type: 'link', text: 'Device Preview', href: '/stylesheet-device-preview' },
      ]
    },
    {
      text: 'Map Release',
      type: 'section',
      defaultExpanded: true,
      items: [
        { type: 'link', text: 'Dashboard', href: '/map-release-dashboard' },
        { type: 'link', text: 'Release Management', href: '/map-release-management' }
      ]
    },
    {
      text: 'GenAI Hub',
      type: 'section',
      defaultExpanded: true,
      items: [
        { type: 'link', text: 'Hub', href: '/maps-data-genai-hub' },
        { type: 'link', text: 'Geo-KB', href: '/geo-kb' },
        { type: 'link', text: 'Road Network Explorer', href: '/road-network-explorer' },
        { type: 'link', text: 'Map Builder Agent', href: '/map-builder-agent' },
        { type: 'link', text: 'Tiles & Themes Agent', href: '/tiles-themes-agent' },
      ]
    },
  ];

  if (showPackViewer === true) {
    (navItems[1] as any).items.push({ type: 'link', text: 'Viewer', href: '/offline-maps-viewer' })
  }

  if (showViewerV2 === true) {
    navItems.push({
      text: 'Experimental',
      type: 'section',
      defaultExpanded: true,
      items: [
        { type: 'link', text: 'Viewer 2.0 (MapLibre)', href: '/viewer-v2' },
        { type: 'link', text: 'Viewer 2.0 - Compare mode', href: '/viewer-v2-compare' },
        { type: 'link', text: 'Viewer 2.0 - Slider mode', href: '/viewer-v2-slider' },
      ]
    });
  }

  if (localOnly === true) {
    (navItems[3] as any).items.push(
      { type: 'link', text: 'Documentation', href: '/stylesheet-doc' },
      { type: 'link', text: 'Validator', href: '/stylesheet-validator' },
      { type: 'link', text: 'Visualization', href: '/stylesheet-viz' },
      { type: 'link', text: 'Diff', href: '/stylesheet-diff' },
      { type: 'link', text: 'Colors', href: '/stylesheet-colors' },
      { type: 'link', text: 'Route Simulator', href: '/stylesheet-route-simulator' },
      { type: 'link', text: 'Manage - Stylesheets', href: '/manage-stylesheets' },
      { type: 'link', text: 'Manage - Fonts', href: '/manage-fonts' },
      { type: 'link', text: 'Manage -Sprites', href: '/manage-sprites' },
      { type: 'link', text: 'Version Explorer', href: '/manage-version-explorer' },
    );
  }

  useEffect(() => {
    setActiveHref(navigationSettings.activePath);
  }, [navigationSettings]);


  return (
    <SideNavigation
      activeHref={activeHref}
      header={{ href: '/', text: 'Tools' }}
      onFollow={event => {
        if (!event.detail.external) {
          event.preventDefault();
          setActiveHref(event.detail.href);
          navigate(event.detail.href);
        }
      }}
      items={navItems}
    />
  );
}